import React, { useRef, useState, useEffect } from "react";
import {
  ChevronRight,
  ThreeDot,
  plus,
  ChevronLeft,
  WalletAdd,
} from "./../../Public/assets/index";
import { Button } from "./../ui/button";
import { useOverview } from "./../../hooks";
import { CurrencyRow } from "./EmptyCard";
import { formatCurrency } from "./../../Utils/helperFunction";

const CurrencyBalance = ({ flag, amount, currency, fullName, disabled }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const {
    setStateVariable,
    setCurrentFlow,
    setIsOpen,
    setTransferCurrency,
    setSelectedCurrency,
  } = useOverview();
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="relative flex z-10 flex-col md:min-w-64 justify-center items-center gap-2.5 py-3 px-[14px] md:p-3 sm:flex-row bg-white rounded-lg min-h-20 shadow-custom"
      onClick={toggleDropdown}
    >
      <div className="flex w-[175px] md:w-max flex-col items-center space-y-[9px] md:gap-3 md:mr-auto md:flex-row">
        <img
          src={flag}
          alt={`${currency} flag`}
          className="w-6 mr-2 rounded-full md:w-8"
        />
        <div className="flex flex-col gap-[9px] items-center justify-center md:items-start md:justify-start">
          <p className="sm:text-xl text-lg leading-[18px] sm:leading-[20px] font-geomanistBold text-blackShade">
            {amount} {currency}
          </p>
          <p className="text-xs leading-[12px] sm:text-[13px] sm:leading-[13px] font-geomanistRegular text-greyish truncate">
            {fullName}
          </p>
        </div>
      </div>

      <button className="absolute flex items-start w-4 h-1 top-4 lg:static right-3 text-greyish">
        <img src={ThreeDot} alt="Three Dot" />
        {isDropdownOpen && !disabled && (
          <div
            ref={dropdownRef}
            className="absolute shadow-2xl  top-4 lg:top-7  right-2 bg-white w-28 md:w-[150px]"
            onClick={() => {}}
          >
            <button
              className="block select-none text-[16px]  px-2 py-1 text-blackShade w-full text-left  hover:bg-gray-100"
              onClick={() => {
                setCurrentFlow("SendMoney");
                setIsOpen(true);
                setStateVariable(1);
                setSelectedCurrency(currency);
                setTransferCurrency(currency);
              }}
            >
              Send {currency}
            </button>
            <hr />
            <button
              className="select-none block w-full text-[16px] px-2 py-1 text-blackShade text-left  hover:bg-gray-100"
              onClick={() => {
                setIsOpen(true);
                setCurrentFlow("WalletTransfer");
                setStateVariable(1);
                setTransferCurrency(currency);
              }}
            >
              Convert {currency}
            </button>
          </div>
        )}
      </button>
    </div>
    // </div>
  );
};

const SmallCurrencyBalance = ({ flag, amount, currency, isLast }) => (
  <div
    // gap-2.5
    className={`relative flex flex-col sm:flex-row z-10 items-center w-auto justify-around  h-[28px] px-5   bg-white ${
      !isLast ? "border-r" : ""
    }`}
  >
    <img
      src={flag}
      alt={`${currency} flag`}
      className="mr-2 w-[21px]  md:w-8 rounded-full"
    />
    <div className=" font-geomanistBold flex justify-center min-w-[70px]  text-[12px] md:text-[16px]">
      {amount === "0.00" ? "0" : amount} {currency}
    </div>
  </div>
);

const CurrencyDisplay = ({ balances = [] }) => {
  if (balances.length < 2) return null;

  // Determine if we're showing 2 or 3 currencies in the top row
  let topRowBalances;
  let bottomBalance;

  if (balances.length === 5) {
    topRowBalances = balances?.slice(0, 3); // First 3 elements
    bottomBalance = balances?.slice(3); // Last 2 elements
  } else {
    // Handle other cases if needed
    topRowBalances = balances?.slice(0, -1);
    bottomBalance = [balances[balances.length - 1]];
  }

  return (
    <div className="">
      <div className="flex flex-col">
        {/* Top row with flexible number of currencies */}
        <div className="flex items-center justify-between mb-4">
          {topRowBalances.map((balance, index) => (
            <SmallCurrencyBalance
              key={index}
              flag={balance.flag}
              amount={balance.amount}
              currency={balance.currency}
              isLast={index === topRowBalances.length - 1}
            />
          ))}
        </div>

        {/* Divider */}
        <div className="mb-2 border-t border-gray-200"></div>

        {/* Bottom currency centered */}
        <div className="flex justify-center">
          {bottomBalance.map((balance, index) => (
            <SmallCurrencyBalance
              key={index}
              flag={balance.flag}
              amount={balance.amount}
              currency={balance.currency}
              isLast={index === bottomBalance.length - 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const QuickActionCard = ({
  icon,
  title1,
  title2,
  isUpcoming,
  bgColor,
  arrow,
  partnerHealthDisable,
  onClick,
}) => (
  // py-[12px]
  <div
    onClick={onClick}
    className={`flex flex-col p-[10px]  py-[12px] space-y-[14px] rounded-lg shadow-sm ${bgColor}`}
  >
    <div className="flex items-start justify-between ">
      <div className="bg-white rounded-full bg-opacity-20">{icon}</div>
      {isUpcoming && (
        <span className="text-xs font-normal  border-2 text-[#FAFAFA] bg-blueish rounded-full px-2 py-1">
          Upcoming
        </span>
      )}
    </div>
    <div className="flex items-center justify-between">
      {/* ${arrow ? "w-[75%]" : "w-[85%]"} */}
      <p className={` max-h-[60px] overflow-hidden   `}>
        <span
          className=" text-nowrap  text-[18px] md:text-[16px] font-[400] font-geomanistBold  leading-[18px]  md:mb-1 
         text-blackShade"
        >
          {title1}
        </span>
        <br />
        <span
          className=" text-[18px] md:text-[16px] font-[400] font-geomanistBold  leading-[18px]  md:mb-1 
         text-blackShade"
        >
          {title2}
        </span>
      </p>
      {arrow && (
        <div className="flex items-center justify-center w-8 h-8 bg-white rounded-full cursor-pointer text-blueish">
          <div style={{ color: "blue" }}>
            <ChevronRight color="blue" size={12} />
          </div>
        </div>
      )}
    </div>
  </div>
);

const CurrencyGrid = ({ noPayment, accounts, disabled }) => {
  const { currencies, mainCurrencies, smallCurrencies } = useOverview();
  const firstGroup = currencies?.slice(0, 3);
  const secondGroup = currencies?.slice(3, 6);
  const scrollContainerRef = useRef(null);
  const [showLeftButton, setShowLeftButton] = useState(false);
  const [showRightButton, setShowRightButton] = useState(true);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const tooltipRef = useRef(null);

  const checkForOverflow = () => {
    const container = scrollContainerRef.current;
    if (container) {
      const hasOverflow = container.scrollWidth > container.clientWidth;
      setShowRightButton(
        hasOverflow &&
          container.scrollLeft <
            container.scrollWidth - container.clientWidth - 10,
      );
      setShowLeftButton(container.scrollLeft > 10);
    }
  };

  const handleScroll = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setShowLeftButton(container.scrollLeft > 10);
      setShowRightButton(
        container.scrollLeft <
          container.scrollWidth - container.clientWidth - 10,
      );
    }
  };

  const handleTooltipClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setIsTooltipOpen(false);
    }
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", checkForOverflow);
      // Initial check after component mounts and content is rendered
      setTimeout(checkForOverflow, 300);
      return () => {
        container.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", checkForOverflow);
      };
    }
  }, [mainCurrencies, smallCurrencies]);

  useEffect(() => {
    document.addEventListener("mousedown", handleTooltipClickOutside);
    document.addEventListener("touchstart", handleTooltipClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleTooltipClickOutside);
      document.removeEventListener("touchstart", handleTooltipClickOutside);
    };
  }, []);

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = container.clientWidth / 2;
      container.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const { setIsOpen, setCurrentFlow, usePartnerWallet } = useOverview();

  const { data: PartnerWe, isError: isPartnerWalletError } = usePartnerWallet();

  // Check if partner wallet data is available
  const hasPartnerWallet =
    !isPartnerWalletError &&
    PartnerWe?.data?.accounts &&
    PartnerWe.data.accounts.length > 0 &&
    PartnerWe?.status !== 404;

  // Get USD balance from partner wallet accounts
  const getUSDBalance = () => {
    if (!hasPartnerWallet) {
      return null;
    }

    // // Find the USD account
    // const usdAccount = PartnerWe.data.accounts.find(
    //   (account) => account.vendorCurrency === "USD"
    // );

    // if (!usdAccount) {
    //   return null;
    // }
    //
    // if (parseInt(PartnerWe.data.accounts[0]?.balance) === 0) {
    //   return null;
    // }

    return {
      balance: PartnerWe.data.accounts[0]?.balance || 0,
      holdBalance: PartnerWe.data.accounts[0]?.holdBalance || 0,
      vendorCurrency: PartnerWe?.data?.accounts[0]?.vendorCurrency,
    };
  };

  const partnerBalance = getUSDBalance();

  return (
    <div className="w-full">
      {noPayment ? (
        <>
          {partnerBalance && (
            <div className="flex items-center gap-2 pl-6 md:px-6 mb-4">
              <h2 className="text-xl font-normal font-geomanistBold text-blackShade">
                Reserve Balance:{" "}
                {formatCurrency(
                  partnerBalance.balance - partnerBalance.holdBalance,
                )}{" "}
                {partnerBalance.vendorCurrency}
              </h2>
              <div className="relative inline-flex group" ref={tooltipRef}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsTooltipOpen(!isTooltipOpen);
                  }}
                  className="cursor-pointer focus:outline-none"
                  aria-label="Information about reserve balance"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#2563eb"
                    className="w-5 h-5"
                  >
                    <circle cx="12" cy="12" r="9" strokeWidth="1.5" />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 16v-4m0-4h.01"
                    />
                  </svg>
                </button>

                {/* Click-based tooltip for mobile */}
                {isTooltipOpen && (
                  <div className="absolute xl:hidden bg-white shadow-lg border border-gray-200 text-gray-600 text-sm font-light py-2 px-3 rounded-lg top-full mt-2  right-[-5px] z-50 w-[280px]">
                    <div className="flex items-center gap-2">
                      <span>
                        This balance is reserved for qualified expenses approved
                        by your loan provider
                      </span>
                    </div>
                  </div>
                )}

                {/* Hover-based tooltip for desktop */}
                <div className="hidden xl:block absolute invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300  text-gray-600 text-sm font-light py-2 px-3 rounded-lg left-full ml-2 top-1/2 transform -translate-y-1/2 whitespace-nowrap z-50">
                  <div className="flex items-center gap-2">
                    <span>
                      This balance is reserved for qualified expenses approved
                      by your loan provider
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="mx-6 px-[19px]  pt-[15px] pb-[39px] bg-noMoneyCard-mobile rounded-xl space-y-[15px] xl:hidden">
            <div className="flex flex-col items-center gap-2 text-center sm:flex-row sm:justify-center">
              <h1 className="text-2xl font-normal font-geomanistBold text-blackShade leading-[35px]">
                Add money to your
              </h1>
              <h2 className="text-2xl leading-[35px] font-medium font-geomanistMedium text-blueish">
                multi-currency account
              </h2>
            </div>
            <div className="flex flex-col space-y-[6.74px]">
              <CurrencyRow items={firstGroup} />
              <CurrencyRow items={secondGroup} />
            </div>
            <div className="z-0 flex justify-center w-auto">
              <Button
                variant="default"
                className="w-auto"
                onClick={() => {
                  setIsOpen(true);
                  setCurrentFlow("AddFunds");
                }}
              >
                <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                  />
                </svg>
                Add Money
              </Button>
            </div>
          </div>

          {/* Desktop version */}
          <div className="hidden xl:block">
            <div
              className="bg-[url('/src/Public/assets/icons/bacgroundCard.svg')]  bg-cover bg-no-repeat
            max-h-[136px] h-[136px]    rounded-xl  mx-6 flex items-center  "
            >
              <div className="flex items-center justify-between w-full rounded-xl">
                <div className=" pl-[38px] w-auto  flex items-center justify-center">
                  <img src={WalletAdd} alt="Wallet" />
                </div>
                <div className="">
                  <div className="mb-4">
                    <h1 className="flex justify-center gap-2 text-2xl font-geomanistBold text-blackShade">
                      Add money to your
                      <span className="text-blue-600 font-geomanistMedium">
                        multi-currency account
                      </span>
                    </h1>
                  </div>

                  <div className="px-2 py-2 bg-white rounded-full shadow-noMoneyShadowLaptop md:px-4">
                    <div className="flex flex-wrap items-center divide-x divide-gray-200">
                      {currencies?.map((currency, index) => (
                        <div
                          key={currency.code}
                          className={`flex items-center justify-center space-x-2 px-4 py-2 transition-colors ${
                            index === 0 ? "" : "pl-4"
                          }`}
                        >
                          <img
                            src={currency.flag}
                            alt={`${currency.code} flag`}
                            className="w-6 h-6 rounded-full"
                          />
                          <span className="font-medium text-gray-800">
                            {currency.code}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="mr-8 backdrop-blur-custom">
                  <Button
                    variant="default"
                    onClick={() => {
                      setIsOpen(true);
                      setCurrentFlow("AddFunds");
                    }}
                  >
                    <img src={plus} alt="plus" className="w-4 h-4 mr-2" /> Add
                    Money
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {partnerBalance && (
            <div className="flex items-center gap-2 pl-6 md:px-6 mb-4">
              <h2 className="text-xl font-normal font-geomanistBold text-blackShade">
                Reserve Balance: {formatCurrency( partnerBalance.balance - partnerBalance.holdBalance)}{" "}
                {partnerBalance.vendorCurrency}
              </h2>
              <div className="relative inline-flex group" ref={tooltipRef}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsTooltipOpen(!isTooltipOpen);
                  }}
                  className="cursor-pointer focus:outline-none"
                  aria-label="Information about reserve balance"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#2563eb"
                    className="w-5 h-5"
                  >
                    <circle cx="12" cy="12" r="9" strokeWidth="1.5" />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 16v-4m0-4h.01"
                    />
                  </svg>
                </button>

                {/* Click-based tooltip for mobile */}
                {isTooltipOpen && (
                  <div className="absolute xl:hidden bg-white shadow-lg border border-gray-200 text-gray-600 text-sm font-light py-2 px-3 rounded-lg top-full mt-2  right-[-5px] z-50 w-[280px]">
                    <div className="flex items-center gap-2">
                      <span>
                        This balance is reserved for qualified expenses approved
                        by your loan provider
                      </span>
                    </div>
                  </div>
                )}

                {/* Hover-based tooltip for desktop */}
                <div className="hidden xl:block absolute invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300  text-gray-600 text-sm font-light py-2 px-3 rounded-lg left-full ml-2 top-1/2 transform -translate-y-1/2 whitespace-nowrap z-50">
                  <div className="flex items-center gap-2">
                    <span>
                      This balance is reserved for qualified expenses approved
                      by your loan provider
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          <h2 className="px-6 mb-4 text-xl font-normal font-geomanistBold text-blackShade">
            Currency Balances ({mainCurrencies?.length}/{accounts?.length})
          </h2>
          <div className="relative flex items-center">
            {showLeftButton && (
              <>
                <div className="absolute left-0 top-0 md:bg-custom-reverse-gradient bottom-0 w-[120px] z-40 pointer-events-none max-h-[92px] hidden md:block" />
                <button
                  className="absolute p-3 text-white rounded-full bg-[#0061D3] left-5 z-50 transform -rotate-90 cursor-pointer shadow-md hidden md:block"
                  onClick={() => scroll("left")}
                  aria-label="Scroll left"
                >
                  <ChevronLeft color="#ffffff" className="w-4 h-4" />
                </button>
              </>
            )}

            <div
              ref={scrollContainerRef}
              className="flex gap-4 px-6 pb-3.5 overflow-x-auto no-scrollbar scroll-smooth"
            >
              <div className="flex my-2 mx-1 gap-4 md:gap-[21px]">
                {mainCurrencies?.map((currency, index) => (
                  <CurrencyBalance
                    key={index}
                    {...currency}
                    disabled={disabled}
                  />
                ))}

                {smallCurrencies?.length > 0 && (
                  <div className="flex items-center bg-white rounded-lg shadow-custom">
                    <div className="px-4 py-2 md:hidden">
                      <div className="px-4 py-2 md:hidden ">
                        <CurrencyDisplay balances={smallCurrencies} />
                      </div>
                    </div>

                    <div className="hidden p-4 md:flex">
                      {smallCurrencies?.map((currency, index) => (
                        <SmallCurrencyBalance
                          key={index}
                          {...currency}
                          isLast={index === smallCurrencies.length - 1}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {showRightButton && (
              <>
                <div className="absolute right-0 top-0 md:bg-custom-gradient bottom-0 w-[120px] z-40 pointer-events-none max-h-[92px] hidden md:block" />
                <button
                  className="absolute z-50 hidden p-3 text-white transform rotate-90 rounded-full shadow-md cursor-pointer right-5 bg-blueish md:block"
                  onClick={() => scroll("right")}
                  aria-label="Scroll right"
                >
                  <ChevronLeft color="#ffffff" className="w-4 h-4" />
                </button>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export {
  SmallCurrencyBalance,
  CurrencyDisplay,
  CurrencyBalance,
  QuickActionCard,
  CurrencyGrid,
};
